/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-07-18 15:30:49
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-07-18 16:03:31
 * @FilePath: \ns-web-evaluation\pc\src\utils\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { UploadFile } from 'ant-design-vue'
import type { UnwrapRef } from 'vue'
import type { RemarkingActiveItem, RemarkingParams } from '@/api/remarking/type'

export const getFinishIdSet = (
  list: RemarkingActiveItem[],
  answers: UnwrapRef<RemarkingParams['answerModel']>
) => {
  const idSetRaw: Set<string> = new Set()
  unref(list).forEach(({ showId }) => {
    let isComplete = true
    Object.entries(answers).forEach(([key, answerList]) => {
      if (key.includes(showId) && !answerList.every((item) => item.score.length > 0)) {
        isComplete = false
      }
    })
    if (isComplete) {
      idSetRaw.add(showId)
    } else {
      idSetRaw.delete(showId)
    }
  })
  return idSetRaw
}

export function numberToCapital(index: number) {
  if (index < 27) return String.fromCharCode(64 + index)
  return String.fromCharCode(97 + index - 27)
}

export interface SetCookieOptions {
  days?: number
  httpOnly?: boolean
  path?: string
}
/**
 * 设置 cookie
 * @param {string} name - cookie 名称
 * @param {string} value - cookie 值
 * @param {object} [options] - cookie 配置选项
 * @param {number} [options.days] - 过期时间,以天为单位
 * @param {boolean} [options.httpOnly] - 是否设置 HttpOnly 属性
 * @param {string} [options.path] - cookie 的路径
 */
export function setCookie(name, value, options: SetCookieOptions) {
  const { days, httpOnly = false, path = '/' } = options || {}

  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }

  let cookie = `${name}=${value || ''}${expires}; path=${path}`
  if (httpOnly) {
    cookie += '; HttpOnly'
  }
  document.cookie = cookie
}

/**
 * 获取 cookie 值
 * @param {string} name - cookie 名称
 * @returns {string|null} - cookie 值,如果不存在则返回 null
 */
export function getCookie(name) {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let c of ca) {
    while (c.charAt(0) === ' ') c = c.slice(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.slice(nameEQ.length, c.length)
  }
  return null
}

export function getUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.trunc(Math.random() * 16)
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function createFile(file: File) {
  const uid = getUuid()
  return reactive<UploadFile>({
    file,
    name: file?.name,
    status: 'uploading',
    percent: 0,
    uid
  })
}
//获取指定父级的距离
export function getOffsetTop(el, parentEl) {
  let offsetTop = 0
  while (el && el !== parentEl) {
    offsetTop += el.offsetTop
    el = el.offsetParent
  }
  return offsetTop
}

/**
 * 判断是否为微信浏览器
 * @returns {boolean} - 是否为微信浏览器
 */
export function isWeixinBrowser() {
  // 微信内置浏览器的User Agent中包含"MicroMessenger"
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger')
}

export function isRealMobile() {
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)
}
